import 'foundation-sites';

export default class {

    constructor() {

        new window.Foundation.OffCanvas($('[data-off-canvas]'), {});

    }

}